import Base from '@studiometa/js-toolkit';
import Flickity from 'flickity-fade';

/**
 * Homepage class.
 */
export default class Slider extends Base {
  /**
   * Class cofnig
   * @type {Object}
   */
  static config = {
    name: 'Slider',
    refs: ['items[]'],
    options: {
      draggable: { type: Boolean, default: true },
      freeScroll: { type: Boolean, default: false },
      wrapAround: { type: Boolean, default: false },
      autoPlay: { type: Number, default: 0 },
      fade: { type: Boolean, default: false },
      contain: { type: Boolean, default: false },
      adaptiveHeight: { type: Boolean, default: false },
      watchCSS: { type: Boolean, default: false },
      freeScrollFriction: { type: Boolean, default: true },
      lazyLoad: { type: Number, default: 0 },
      cellAlign: { type: String, default: 'center' },
      prevNextButtons: { type: Boolean, default: true },
      pageDots: { type: Boolean, default: false },
      scrollbar: { type: Boolean, default: false },
    },
  };

  /**
   * Log a nice message when app is ready.
   *
   * @return {void}
   */
  mounted() {
    if (this.$refs.items) {
      const params = {
        cellSelector: `[class="${this.$refs.items[0].className}"]`,
      };

      if (this.$options.scrollbar) {
        const scrollbar = document.createElement('div');
        scrollbar.classList.add('slider__scrollbar');
        this.$el.append(scrollbar);

        const bar = document.createElement('div');
        bar.classList.add('bar');
        scrollbar.append(bar);

        params.on = {
          scroll: (progress) => {
            if (bar) {
              bar.style.width = `${progress * 100}%`;
            }
          },
        };
      }

      const atts = Object.assign(this.$options, params);
      this.slider = new Flickity(this.$el, atts);
    }
  }
}
